import { DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type EventApplicationModuleSpecsFragment } from '../../../../api/fragments/EventApplicationModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { EditMode } from './type';

export type EventApplicationModuleActionProps = {
    module: EventApplicationModuleSpecsFragment;
    setEditMode: (value: EditMode) => void;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const EventApplicationModuleAction = ({ module, setEditMode, permissions }: EventApplicationModuleActionProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('eventApplicationModuleDetails:actions.updateVehicleAssignments'),
            key: 'updateVehicleAssignments',
            icon: <EditOutlined />,
            onClick: () => setEditMode(EditMode.Vehicles),
        },
        hasUpdatePermission && {
            label: t('eventApplicationModuleDetails:actions.updateFinanceProductAssignments'),
            key: 'updateFinanceProductAssignments',
            icon: <EditOutlined />,
            onClick: () => setEditMode(EditMode.FinanceProducts),
        },
        hasDeletePermission && {
            label: t('eventApplicationModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('eventApplicationModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default EventApplicationModuleAction;
